module.exports = __webpack_public_path__ + "static/media/svg_3_2_1_rijbaan_r.5d8510f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/03/02/assets/svg_3_2_1_rijbaan_r.svg
// module id = 496
// module chunks = 0